


















































































































































import {Component, Vue} from "vue-property-decorator";
import * as Constants from "@/Constants";
import {Getter} from "vuex-class";
import {User} from "front-component/modules/User";
import {Budget} from "@/modules/budget/Budget";
import {Topic} from "@/modules/Topic";
import Owner from "@/model/cospirit-api/Owner";
import {Type} from "@/modules/request/Type";
import _ from "lodash";
import {Notification} from "@/modules/request/Notification";
import Tag from "@/components/miscellaneous/Tag.vue";
import NotificationRepository from "@/repositories/request/NotificationRepository";
import {BudgetAllocation} from "@/modules/budget/BudgetAllocation";
import moment from "moment";

interface OptionTrigger {
    key: string;
    label: string;
}

interface OptionStatusRequest {
    key: string;
    label: string;
    tag?: boolean;
    hidden?: boolean;
}

const components = {
    Tag
};

@Component({components})
export default class EditNotificationRequest extends Vue {
    private optionsTrigger: OptionTrigger[] = Constants.optionsTrigger;
    private optionsStatusRequest: OptionStatusRequest[] = Constants.optionsStatusRequest;
    private notificationChannels: { [channel: string]: string } = Constants.notificationChannels;
    private notificationAllStatus: { [key: string]: string } = Constants.notficationStatusDetails;
    private documentTypesBuffer: string[] = [];
    private notification: Notification | null = null;
    private loadingNotification = false;
    private optionsRequesters: Array<{ key: string; label: string; }> = [];
    private selectedRequesters: string[] = [];
    private notificationRequestChoice = "";
    private notificationRequestTrigger = Constants.notificationRequestTrigger;

    @Getter("getCurrentOwnerUuid") public ownerUuid!: string;
    @Getter("getCurrentUser") public user!: User;
    @Getter("getBudgetAllocations") protected budgetAllocations!: (ownerUuid: string) => void;
    @Getter("getBudgets") protected budgets!: Budget[];
    @Getter("getAllTopics") public topics!: Topic[];
    @Getter("getOwners") public owners!: Owner[];
    @Getter("getTypes") public types!: Type[];
    @Getter("hasFeature") public hasFeature!: (feature: string) => boolean;
    @Getter("getUserDepartment") public userDepartment!: string;
    @Getter("getOwnerWorkflow") public getOwnerWorkflow!: (isClient: boolean) => { [p: string]: string[] };
    @Getter("getRequesters") public requesters!: User[];

    private mounted(): void {
        this.setOptionsStatus();
        if (this.$route.params.uuid) {
            this.getNotification(this.$route.params.uuid);
        } else {
            this.editNotification(null);
        }
    }

    private notificationStatusChange(status: string[]): void {
        if (status.includes(this.notificationAllStatus.allStatus) && this.notification) {
            this.notification.status = [this.notificationAllStatus.allStatus];
        }
    }

    private getNotification(uuid: string): void {
        this.loadingNotification = true;
        const params = {
            filters: {
                uuid
            },
        };
        NotificationRepository.get(params).then((notification) => {
            const firstNotification = notification[0] as Notification;
            this.editNotification(firstNotification);
            if (firstNotification.requesters && firstNotification.requesters.length > 0) {
                this.selectedRequesters = firstNotification.requesters
                    .map((requester) => requester.uuid)
                    .filter((value): value is string => typeof value === "string");
            } else {
                this.selectedRequesters = [""];
            }
            this.loadingNotification = false;
        }).catch(() => {
            this.loadingNotification = false;
        });
    }


    private changeSelectedRequesters(values: string[] = []): void {
        if (values[0] === "" && values.length > 1) {
            values = values.filter((v) => v !== "");
        } else if (values[values.length - 1] === "" && values.length > 1) {
            values = [""];
        } else if (values.length === 0) {
            values = [""];
        }
        this.selectedRequesters = values;
    }


    private editNotification(notification: Notification | null): void {
        this.notification = {
            uuid: _.get(notification, "uuid", null),
            trigger: _.get(notification, "trigger", Constants.STATUS_CHANGED),
            channels: _.get(notification, "channels", ["email"]),
            requesters: _.get(notification, "requesters", []),
            affected: {
                uuid: _.get(notification, "affected.uuid", ""),
            },
            follower: {
                uuid: _.get(notification, "follower.uuid", ""),
            },
            ownersUuid: _.get(notification, "ownersUuid", [this.ownerUuid]),
            status: _.get(notification, "status", []),
            type: _.get(notification, "type", ""),
            topic: {
                uuid: _.get(notification, "topic.uuid", ""),
            },
            budgetAllocation: {
                uuid: _.get(notification, "budgetAllocation.uuid", ""),
            },
            documentTypes: _.get(notification, "documentTypes", [""]),
            isActive: _.get(notification, "isActive", true),
        };
        if (this.notification.documentTypes.length === 0) {
            this.notification.documentTypes = [""];
        }

        if (1 === this.owners.length) {
            const ownerUuid = _.get(_.first(this.owners), "uuid");
            if (this.notification.ownersUuid.length === 0) {
                this.notification.ownersUuid.push(ownerUuid as string);
            }
            this.setOptionsStatus();
        }

        if (!this.user.department && 0 === this.notification.ownersUuid.length && 0 < this.owners.length) {
            this.notification.ownersUuid.push(this.ownerUuid);
        }
    }

    private setOptionsStatus(): void {
        const requestStatusClientSM = this.getOwnerWorkflow(true);

        _.forEach(this.optionsStatusRequest, (status) => {
            status.hidden = !_.has(requestStatusClientSM, status.key) || !_.get(status, "tag", false);
        });
    }

    private changeDocumentType(values: string[]): void {
        const newDocumentType = values.filter((x) => !this.documentTypesBuffer.includes(x))[0];
        const hasAlreadyAllDocumentType = this.documentTypesBuffer.includes("");

        if (newDocumentType === "") {
            values = [""];
        } else if (hasAlreadyAllDocumentType && values.length > 0) {
            _.remove(values, (x) => x === "");
        } else if (values.length === 0) {
            values = [""];
        }

        this.documentTypesBuffer = values;
        if (this.notification) {
            this.notification.documentTypes = this.documentTypesBuffer;
        }
    }

    private get optionsFollowers(): Array<{ key: string; label: string }> {
        const optionsResult = [];
        optionsResult.push({key: "", label: "allFollowed"});
        optionsResult.push({key: this.user.uuid, label: "myFollowedRequests"});

        return optionsResult;
    }

    private get optionsAllocations(): Array<{ key: string; label: string; year: string }> {
        const optionsResult = [
            {
                key: "",
                label: _.invoke(this.$options.filters, "trans", "allBudgets"),
                year: "",
            }];

        const result = _.concat(
            optionsResult,
            _.map(this.budgetAllocations, (budgetAllocation: BudgetAllocation, key) => {
                const budgetFound = _.find(this.budgets, (budget) => {
                    return budget.uuid === budgetAllocation.budget.uuid;
                });

                const year = moment(_.get(budgetFound, "beginDate", ""), "YYYYMMDD").format("YYYY");
                return {key: budgetAllocation.uuid, label: budgetAllocation.label, year};
            })
        );

        return _.sortBy(result, (line) => {
            return !line.year + line.year + line.label;
        });
    }

    private get optionsRequester(): Array<{
        label: string;
        options: Array<{ value: string; label: string }>;
    }> {
        const groupedOptions: Array<{ label: string; options: Array<{ value: string; label: string }> }> = [];

        groupedOptions.push({
            label: _.invoke(this.$options.filters, "trans", "defaultFiltersRequesters"),
            options: [
                { value: "", label: Constants.notificationRequestTrigger.allRequesters },
                { value: this.user.uuid, label: Constants.notificationRequestTrigger.myRequests },
            ],
        });

        const requesterOptions: Array<{ value: string; label: string }> = [];
        _.forEach(this.requesters, (requester: User) => {
            if (requester.uuid && requester.displayName) {
                const alreadyExists = requesterOptions.some((opt) => opt.value === requester.uuid);
                if (!alreadyExists && requester.uuid !== this.user.uuid) {
                    requesterOptions.push({
                        value: requester.uuid,
                        label: requester.displayName,
                    });
                }
            }
        });

        if (requesterOptions.length > 0) {
            groupedOptions.push({
                label: _.invoke(this.$options.filters, "trans", "usersRequest"),
                options: requesterOptions,
            });
        }

        return groupedOptions;
    }

    public get optionsDocumentTypes(): Array<{ key: string; label: string }> {
        const options = [{
            key: "",
            label: _.invoke(this.$options.filters, "trans", "" + "allDocumentTypes"),
        }];

        const sortedDocumentTypes = _.sortBy(Constants.requestDocumentTypes, (documentType) => {
            return _.invoke(this.$options.filters, "trans", documentType);
        });
        _.forEach(sortedDocumentTypes, (type, key) => {
            options.push({key: type, label: type});
        });

        return options;
    }

    public get optionsType(): Array<{ key: string; label: string }> {
        const options = [{
            key: "",
            label: _.invoke(this.$options.filters, "trans", "" + "allRequestTypes"),
        }];

        _.forEach(this.types, (type: Type) => {
            options.push({key: type.label, label: type.label});
        });
        return options;
    }

    private get orderedOptions(): Array<{ key: string; label: string }> {
        const options = [{
            key: "",
            label: _.invoke(
                this.$options.filters,
                "trans",
                "allTopics"
            ),
        }];

        _.forEach(this.topics, (topic) => {
            if (!topic.parent) {
                options.push({key: topic.uuid, label: topic.title});
                const currentUuid = topic.uuid;
                _.forEach(this.topics, (subtopic) => {
                    if (subtopic.parent && subtopic.parent.uuid === currentUuid) {
                        options.push({key: subtopic.uuid, label: "- " + subtopic.title});
                    }
                });
            }
        });

        return options;
    }

    private get optionsAffected(): Array<{ key: string; label: string }> {
        const optionsResult = [];
        optionsResult.push({key: "", label: "allAffected"});
        optionsResult.push({key: this.user.uuid, label: "myRequests"});

        return optionsResult;
    }

    private saveNotification(): void {
        this.loadingNotification = true;
        const saveNotification = _.cloneDeep(this.notification) as Notification;
        if ("" === _.get(saveNotification, "affected.uuid", "")) {
            _.set(saveNotification, "affected", null);
        }
        if ("" === _.get(saveNotification, "follower.uuid", "")) {
            _.set(saveNotification, "follower", null);
        }
        if ("" === _.get(saveNotification, "topic.uuid", "")) {
            _.set(saveNotification, "topic", null);
        }
        if ("" === _.get(saveNotification, "budgetAllocation.uuid", "")) {
            _.set(saveNotification, "budgetAllocation", null);
        }
        if (_.get(saveNotification, "documentTypes", "")[0] === "") {
            _.set(saveNotification, "documentTypes", []);
        }
        if (this.selectedRequesters.includes("") || this.selectedRequesters.length === 0) {
            saveNotification.requesters = [];
        } else {
            saveNotification.requesters = _.map(this.selectedRequesters, (requesterUuid) => {
                return {uuid: requesterUuid};
            });
        }
        NotificationRepository.save(saveNotification).then(() => {
            this.$message({
                message: _.invoke(this.$options.filters, "trans", "saveNotificationSuccess"),
                type: "success"
            });
            this.loadingNotification = false;
            this.$router.push({
                name: "notifications_request_list"
            });
        });
    }

    private get canSaveNotification(): boolean {
        return (!!this.user.department || (!!this.notification && 0 < this.notification.ownersUuid.length))
            && (!!this.notification && 0 < this.notification.channels.length);
    }

    private cancelEditNotification(): void {
        this.$router.push({
            name: "notifications_request_list",
        });
    }
}
